import React from 'react';
import { escapeHtml } from '../../utils/helpers';

const CoverLetterPreview = ({ coverData }) => {
    const { personal, recipient, jobDetails, content, additional } = coverData;
    
    const today = new Date().toLocaleDateString('en-ZA', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    });

    const getGreeting = () => {
        const managerName = recipient.hiringManagerName?.trim();
        if (managerName && managerName !== 'Hiring Manager') {
            return `Dear ${escapeHtml(managerName)},`;
        }
        return 'Dear Hiring Manager,';
    };

    return (
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl overflow-hidden">
            <div className="p-8 md:p-10">
                {/* Header with contact info */}
                <div className="text-center mb-8 pb-6 border-b border-gray-200">
                    <h1 className="text-2xl font-bold text-gradpath-dark mb-2">{escapeHtml(personal.fullName)}</h1>
                    <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600">
                        {personal.email && (
                            <span className="inline-flex items-center gap-1">
                                <i className="fas fa-envelope text-gradpath-green text-xs"></i> {escapeHtml(personal.email)}
                            </span>
                        )}
                        {personal.phone && (
                            <span className="inline-flex items-center gap-1">
                                <i className="fas fa-phone text-gradpath-green text-xs"></i> {escapeHtml(personal.phone)}
                            </span>
                        )}
                        {personal.address && (
                            <span className="inline-flex items-center gap-1">
                                <i className="fas fa-map-marker-alt text-gradpath-green text-xs"></i> {escapeHtml(personal.address)}
                            </span>
                        )}
                    </div>
                    {(additional.portfolio || additional.linkedin) && (
                        <div className="flex flex-wrap justify-center gap-4 mt-2 text-sm">
                            {additional.portfolio && (
                                <a href={additional.portfolio} target="_blank" rel="noopener noreferrer" 
                                   className="text-gradpath-green hover:underline inline-flex items-center gap-1">
                                    <i className="fab fa-github"></i> Portfolio
                                </a>
                            )}
                            {additional.linkedin && (
                                <a href={additional.linkedin} target="_blank" rel="noopener noreferrer"
                                   className="text-gradpath-green hover:underline inline-flex items-center gap-1">
                                    <i className="fab fa-linkedin"></i> LinkedIn
                                </a>
                            )}
                        </div>
                    )}
                </div>

                {/* Date and Recipient */}
                <div className="mb-8">
                    <p className="text-gray-600 mb-4">{today}</p>
                    <div className="text-gray-700">
                        {recipient.hiringManagerName && recipient.hiringManagerName !== 'Hiring Manager' && (
                            <p>{escapeHtml(recipient.hiringManagerName)}</p>
                        )}
                        <p>{escapeHtml(recipient.companyName)}</p>
                        {recipient.companyAddress && <p>{escapeHtml(recipient.companyAddress)}</p>}
                    </div>
                </div>

                {/* Subject Line */}
                <div className="mb-6">
                    <p className="font-semibold text-gradpath-dark">
                        RE: {escapeHtml(jobDetails.jobTitle)} Position
                        {jobDetails.jobReference && ` (Ref: ${escapeHtml(jobDetails.jobReference)})`}
                    </p>
                </div>

                {/* Greeting */}
                <div className="mb-4">
                    <p className="text-gray-700">{getGreeting()}</p>
                </div>

                {/* Letter Body */}
                <div className="space-y-4 text-gray-700 leading-relaxed">
                    {content.opening && (
                        <p className="whitespace-pre-line">{escapeHtml(content.opening)}</p>
                    )}
                    {content.body && (
                        <p className="whitespace-pre-line mt-4">{escapeHtml(content.body)}</p>
                    )}
                    {content.closing && (
                        <p className="whitespace-pre-line mt-4">{escapeHtml(content.closing)}</p>
                    )}
                </div>

                {/* Signature */}
                <div className="mt-8 pt-4">
                    <p className="text-gray-700">Sincerely,</p>
                    <p className="text-gray-700 mt-4 font-semibold">{escapeHtml(personal.fullName)}</p>
                </div>
            </div>
        </div>
    );
};

export default CoverLetterPreview;